<template>
    <section class=" flex font-poppins">
        <div class=" border pt-8 flex flex-col justify-around lg:hidden " style="border-bottom: none ">
            <div class=" flex flex-col">
                <p v-if="warningZone"></p>
                <div class="pl-20 pr-20">
                    <img class="lg:pl-10 md:pt-3"  src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg" alt="logo">
                </div>

                <router-link to="/admin/dashboard" >
                    <div :class="{admin: $route.name === 'admin-dashboard'}" class=" pl-10 pr-10 flex mt-14 hover:bg-blue-600 text-gray-400 hover:text-white">
                        <img src="./assets/dashboard-icon.svg" alt="icon">
                        <p class="ml-4 p-2 " >Dashboard</p>
                    </div>
                </router-link>    
                <div>
                    <router-link to="/manage-orders" v-if="orders == 'orders' ">
                        <div :class="{admin: $route.name === 'orders'}" class="  pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img src="./assets/orders-icon.svg" alt="icon">
                            <p class="ml-4 p-2" >Orders</p>
                        </div>
                    </router-link>
                    <router-link to="/manage-orders"  v-if="orders == 'error' ">
                        <div :class="{admin: $route.name === 'orders'}" class="  pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img src="./assets/orders-icon.svg" alt="icon">
                            <p class="ml-4 p-2" >Orders</p>
                        </div>
                    </router-link>
                </div>
                <div>
                    <router-link to="/manage-users" v-if="users == 'users' ">
                        <div :class="{admin: $route.name === 'users'}" class=" pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img src="./assets/users-icon.svg" alt="icon">
                            <p class="ml-4 p-2"  >Users</p>
                        </div>
                    </router-link>
                    <router-link to="/manage-users" v-if="users == 'error' ">
                        <div :class="{admin: $route.name === 'users'}" class=" pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img src="./assets/users-icon.svg" alt="icon">
                            <p class="ml-4 p-2"  >Users</p>
                        </div>
                    </router-link>
                </div>
                <div>
                    <router-link to="/manage-riders" v-if="riders == 'riders' ">    
                        <div :class="{admin: $route.name === 'riders'}" class=" pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img src="./assets/dso-icon.svg" alt="icon">
                            <p class="ml-4 p-2" >Carriers</p>
                        </div>
                    </router-link>
                    <router-link to="/manage-riders" v-if="riders == 'error' ">    
                        <div :class="{admin: $route.name === 'riders'}" class=" pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img src="./assets/dso-icon.svg" alt="icon">
                            <p class="ml-4 p-2" >Carriers</p>
                        </div>
                    </router-link>
                </div>
                <div>
                    <router-link to="/manage-dsos" v-if="dsos == 'dsos' ">    
                        <div :class="{admin: $route.name === 'dsos'}" class=" pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img src="./assets/dso-icon.svg" alt="icon">
                            <p class="ml-4 p-2">DSOs</p>
                        </div>
                    </router-link> 
                    <router-link to="/manage-dsos" v-if="dsos == 'error' ">    
                        <div :class="{admin: $route.name === 'dsos'}" class=" pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img src="./assets/dso-icon.svg" alt="icon">
                            <p class="ml-4 p-2">DSOs</p>
                        </div>
                    </router-link> 
                </div>
                <div>
                    <router-link to="/manage-admin" v-if="manageAdmin == 'manageAdmin' ">    
                        <div :class="{admin: $route.name === 'manage-admin'}" class=" pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img class="w-5 mt-3 h-6" src="./assets/Vector.png" alt="icon">
                            <p class="ml-4 p-2">Manage Admins</p>
                        </div>
                    </router-link>
                    <router-link to="/manage-admin" v-if="manageAdmin == 'error' ">    
                        <div :class="{admin: $route.name === 'manage-admin'}" class=" pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img class="w-5 mt-3 h-6" src="./assets/Vector.png" alt="icon">
                            <p class="ml-4 p-2">Manage Admins</p>
                        </div>
                    </router-link>
                </div>
                <div>
                    <router-link to="/transaction-history" v-if="transactions == 'transactions' ">    
                        <div :class="{admin: $route.name === 'transaction-history'}" class=" pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img class="w-5 mt-3 h-6" src="./assets/Vector(1).png" alt="icon">
                            <p class="ml-4 p-2" >Transactions</p>
                        </div>
                    </router-link>
                     <router-link to="/transaction-history" v-if="transactions == 'error' ">    
                        <div :class="{admin: $route.name === 'transaction-history'}" class=" pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img class="w-5 mt-3 h-6" src="./assets/Vector(1).png" alt="icon">
                            <p class="ml-4 p-2" >Transactions</p>
                        </div>
                    </router-link>
                </div>
                <div>
                    <router-link to="/configuration" v-if="configuration == 'configuration' ">    
                        <div :class="{admin: $route.name === 'configuration'}" class=" pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img class="w-5 mt-3 h-6" src="./assets/Vector(2).png" alt="icon">
                            <p class="ml-4 p-2" >Configuration </p>
                        </div>
                    </router-link>
                    <router-link to="/configuration" v-if="configuration == 'error' ">    
                        <div :class="{admin: $route.name === 'configuration'}" class=" pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img class="w-5 mt-3 h-6" src="./assets/Vector(2).png" alt="icon">
                            <p class="ml-4 p-2" >Configuration </p>
                        </div>
                    </router-link>
                </div>
                <div>
                    <router-link to="/admin-wallet" v-if="adminWallet == 'adminWallet' ">    
                        <div :class="{admin: $route.name === 'admin-wallet'}" class=" pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img class="w-5 mt-3 h-6" src="./assets/Group.png" alt="icon">
                            <p class="ml-4 p-2" >Admin Wallet</p>
                        </div>
                    </router-link>    
                     <router-link to="/admin-wallet" v-if="adminWallet == 'error' ">    
                        <div :class="{admin: $route.name === 'admin-wallet'}" class=" pl-10 pr-10 flex mt-10 hover:bg-blue-600 text-gray-400 hover:text-white">
                            <img class="w-5 mt-3 h-6" src="./assets/Group.png" alt="icon">
                            <p class="ml-4 p-2" >Admin Wallet</p>
                        </div>
                    </router-link>    

                </div>
            </div>   

            <div>
                <router-link to="/admin-settings">
                    <div :class="{admin: $route.name === 'settings'}" class=" pl-10 pr-10 hover:bg-blue-600 text-gray-400 hover:text-white flex mt-4 cursor-pointer">
                        <img src="./assets/settings-icon.svg" alt="icon">
                        <p class="ml-4 p-2" >Settings</p>
                    </div>
                </router-link>
                <router-link to="/admin-logout">    
                    <div :class="{admin: $route.name === 'logout'}" class=" pl-10 pr-10 hover:bg-blue-600 text-gray-400 hover:text-white flex mt-4 cursor-pointer">
                        <img src="./assets/logout-icon.svg" alt="icon">
                        <p class="ml-4 p-2" >Logout</p>
                    </div>
                </router-link>    
            </div> 
        </div>

        <div>
            <div>
                <i class=" fa fa-bars fa-2x text-blue-600 hidden  lg:block mt-4 text-2xl pr-10" @click="toggleMobileNav" :class="{'icon-active' : mobileNav}"></i>
            </div>

            
        </div>

        <transition name="mobile-nav" class="w-full md:text-sm">
                <nav v-show="mobileNav" class="dropDDownNav flex z-20">
                    <div class="w-1/2 bg-gray-200 absolute top-0 left-0 rounded-r-2xl h-screen p-2">
                        <ul>
                            <li class="p-2 font-semibold text-black"><router-link to="/admin/dashboard">Dashboard</router-link></li>
                            <li v-if="orders == 'orders' " class=" p-2 font-semibold mt-2 text-black"><router-link :class="{active: $route.name === 'manage-orders'}" to="/manage-orders"> Manage Orders</router-link></li>
                            <li v-if="orders == 'error' " class=" p-2 font-semibold mt-2 text-black"><router-link :class="{active: $route.name === 'manage-orders'}" to="/manage-orders"> Manage Orders</router-link></li>
                            <li v-if="users == 'users' " class=" p-2 font-semibold mt-2 text-black"><router-link to="/manage-users"> Manage Users</router-link></li>
                            <li v-if="users == 'error' " class=" p-2 font-semibold mt-2 text-black"><router-link to="/manage-users"> Manage Users</router-link></li>
                            <li v-if="riders == 'riders' " class=" p-2 font-semibold mt-2 text-black"><router-link  to="/manage-riders">Manage Carriers</router-link></li>
                            <li v-if="riders == 'error' " class=" p-2 font-semibold mt-2 text-black"><router-link  to="/manage-riders">Manage Carriers</router-link></li>
                            <li v-if="dsos == 'dsos' " class=" p-2 font-semibold mt-2 text-black"><router-link to="/manage-dsos">Manage Dso</router-link></li>
                            <li v-if="dsos == 'error' " class=" p-2 font-semibold mt-2 text-black"><router-link to="/manage-dsos">Manage Dso</router-link></li>
                            <li v-if="manageAdmin == 'manageAdmin' " class=" p-2 font-semibold mt-2 text-black"><router-link to="/manage-admin">Manage Admin</router-link></li>
                            <li v-if="manageAdmin == 'error' " class=" p-2 font-semibold mt-2 text-black"><router-link to="/manage-admin">Manage Admin</router-link></li>
                            <li v-if="adminWallet == 'adminWallet' " class=" p-2 font-semibold mt-2 text-black"><router-link to="/admin-wallet">Admin Wallet</router-link></li>
                            <li v-if="adminWallet == 'error' " class=" p-2 font-semibold mt-2 text-black"><router-link to="/admin-wallet">Admin Wallet</router-link></li>
                            <li v-if="configuration == 'configuration' " class=" p-2 font-semibold mt-2 text-black"><router-link to="/configuration">Configurations</router-link></li>
                            <li v-if="configuration == 'error' " class=" p-2 font-semibold mt-2 text-black"><router-link to="/configuration">Configurations</router-link></li>
                            <li v-if="transactions == 'transactions' " class=" p-2 font-semibold mt-2 text-black"><router-link to="/transaction-history">Transaction</router-link></li>
                            <li v-if="transactions == 'error' " class=" p-2 font-semibold mt-2 text-black"><router-link to="/transaction-history">Transaction</router-link></li>
                            <li class=" p-2 font-semibold mt-2 text-black"><router-link  to="/admin-settings">Settings</router-link></li>
                            <li class=" p-2 font-semibold mt-2 text-black"><router-link  to="/admin-logout">Logout</router-link></li>
                        </ul>
                    </div>
                    <div @click="toggleMobileNav" class="modal-backdrop w-1/2"></div>
                </nav>
            </transition>

    </section>
</template>


<script>
import axios from 'axios';
import {baseUrl} from '../../Config';
const url = baseUrl;
export default {
     data() {
        return {
            mobile: true,
            mobileNav: null,
            admins: [],
            userId: localStorage.getItem("userId"),
            dashboard: "",
            orders: "",
            users: "",
            riders: "",
            dsos: "",
            manageAdmin: "",
            transactions: "",
            configuration: "",
            adminWallet: "",
            events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
            logoutTimer: null,
            warningTimer : null,
            warningZone: false,
            token : localStorage.getItem('refereshToken'),
            id : localStorage.getItem('userId'),
            

        }
    },

    mounted() {
        this.networkError();
        this.getAdmin();
         this.events.forEach(function (event) {
             window.addEventListener(event, this.resetTimer)
         }, this);
         this.setTimers();
    },

     unmounted() {
         this.events.forEach(function (event) {
             window.removeEventListener(event, this.resetTimer)
         }, this);
         this.resetTimer();
     },

    methods: {
        setTimers() {
            this.warningTimer = setTimeout(this.warningMessage, 9 * 60 * 1000);
            this.logoutTimer = setTimeout(this.logoutUser, 10 * 60 * 1000); //15 * 60 * 1000
            this.warningZone = false;
        },
        warningMessage() {
            this.warningZone = true;
        },

         logoutUser() {
             axios({
          method: 'post',
          url: `${url}/v1/web/auth/logout`,
          headers: {
              'Content-type': 'application/json',
              'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3',
          },
          data: {
              refreshToken: this.token,
              userId : this.id,
          }
          })
          .then((res) => {
            res
            this.isLoading = false;
            localStorage.removeItem('ipAddress')
             localStorage.removeItem('user')
             localStorage.removeItem('refereshToken')
             localStorage.removeItem('userEmail')
             localStorage.removeItem('userType')
             localStorage.removeItem('token')
             localStorage.removeItem('userId')
            this.$router.push("/admin/login");
          })
          .catch((err) => err)
        },

        resetTimer(){
            clearTimeout(this.warningTimer);
            clearTimeout(this.logoutTimer);

            this.setTimers();
        },

        toggleMobileNav() {
            this.mobileNav = !this.mobileNav
        },

        getAdmin() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/users/admin/${this.userId}`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3',
                    Authorization: 'Bearer ' + localStorage.getItem("token")
                },
                })
                .then((response) => {
                    this.admins = response.data.data
                    let privileges = this.admins.privileges
                    for(let i = 0; i < privileges.length; i++) {
                        if(privileges[i] == "Users") {
                            this.users = "users"
                        } 
                        if(privileges[i] == "Orders") {
                            this.orders = "orders"
                        } 
                        if(privileges[i] == "Riders") {
                            this.riders = "riders"
                        } 
                        if(privileges[i] == "DSOs") {
                            this.dsos = "dsos"
                        } 
                        if(privileges[i] == "Admin Wallet") {
                            this.adminWallet = "adminWallet"
                        } 
                        if(privileges[i] == "Manage Admin") {
                            this.manageAdmin = "manageAdmin"
                        }
                        if(privileges[i] == "Transactions") {
                            this.transactions = "transactions"
                        } 
                        if(privileges[i] == "Configuration") {
                            this.configuration = "configuration"
                        } 
                    }
                })
                .catch((err) => {
                    this.error = err.response.data.messsage
                    this.users = "error"
                    this.orders = "error"
                    this.riders = "error"
                    this.dsos = "error"
                    this.adminWallet = "error"
                    this.manageAdmin = "error"
                    this.transactions = "error"
                    this.configuration = "error"
                })
        }, 

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        },


    }
}
</script>

<style scoped>
.admin {
    color: #0048AE;
    border-right: 2px solid #0048AE;
    background: rgb(162, 172, 204);
    color:#0048AE;
}
.modal-backdrop {
    position: absolute;
    top: 0;
    right: 0;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.2);
  }
</style>







